import styles from './styles.module.scss';
import React from 'react';

const SplashLoader = ({ content }) => {
  return (
    <div className={`relative ${styles.container}`}>
      <span class={styles.loader}></span>
    </div>
  );
};
export default SplashLoader;
